/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { GetBootstrap200Response } from '../models';
/**
 * WebViewApi - axios parameter creator
 */
export const WebViewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getBootstrap
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBootstrap: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/web-view/bootstrap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebViewApi - functional programming interface
 */
export const WebViewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebViewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getBootstrap
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBootstrap(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBootstrap200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBootstrap(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebViewApi.getBootstrap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebViewApi - factory interface
 */
export const WebViewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebViewApiFp(configuration)
    return {
        /**
         * 
         * @summary getBootstrap
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBootstrap(options?: RawAxiosRequestConfig): AxiosPromise<GetBootstrap200Response> {
            return localVarFp.getBootstrap(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebViewApi - object-oriented interface
 */
export class WebViewApi extends BaseAPI {
    /**
     * 
     * @summary getBootstrap
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getBootstrap(options?: RawAxiosRequestConfig) {
        return WebViewApiFp(this.configuration).getBootstrap(options).then((request) => request(this.axios, this.basePath));
    }
}

